import Billing from "./pages";
import BillingButtonComponent from "./components/BillingButton";
import UpgradeDialogComponent from "./components/UpgradeDialog";
import BillingForPaidUserComponent from "./components/BillingForPaidUser";

export default Billing;
export const BillingButton = BillingButtonComponent;
export const UpgradeDialog = UpgradeDialogComponent;
export const BillingForPaidUser = BillingForPaidUserComponent;